import initDialog from './dialogs/cosmohint'
// import icon from './icons/cosmohint.png'
// const iconUrl = require('./icons/cosmohint.png')
/* eslint-disable */
export default function initPlugin() {
  if (CKEDITOR.plugins.get('cosmohint')) {
    return
  }

  CKEDITOR.plugins.add('cosmohint', {
    icons: 'cosmohint',
    requires: ['dialog', 'fakeobjects'],
    init: function (editor) {
      const getCosmohintToolEl = () => {
        const cosmohintId = editor.ui.get('cosmohint')?._?.id

        const cosmohintEl = cosmohintId
          ? document.getElementById(cosmohintId)
          : null

        return cosmohintEl
      }

      const toggleHiddenSpoilerTool = (isHidden) => {
        const cosmohintEl = getCosmohintToolEl()

        if (!cosmohintEl) {
          return
        }

        if (isHidden) {
          cosmohintEl.setAttribute('data-disabled', '1')
        } else {
          cosmohintEl.removeAttribute('data-disabled')
        }
      }

      editor.on('doubleclick', function (e) {
        const element = e.data.element

        if (element.is('span') && element.hasClass('cosmohint')) {
          e.data.dialog = 'cosmohintDialog'
        }
      })

      editor.on('selectionChange', () => {
        toggleHiddenSpoilerTool(
          !!editor.editable().findOne('.widget-spoiler-blur') ||
            !!editor.editable().findOne('.widget-spoiler-flicker')
        )
      })

      editor.lang.fakeobjects.cosmohint = 'Всплывающая подсказка'

      // Define an editor command that opens our dialog.
      editor.addCommand(
        'cosmohint',
        new CKEDITOR.dialogCommand('cosmohintDialog')
      )

      // Create a toolbar button that executes the above command.
      editor.ui.addButton('cosmohint', {
        // The text part of the button (if available) and tooptip.
        label: 'Вставить всплывающую подсказку',

        // The command to execute on click.
        command: 'cosmohint',

        icon: 'cosmohint',

        // The button placement in the toolbar (toolbar group name).
        toolbar: 'insert',
      })

      // Register our dialog file. this.path is the plugin folder path.
      // CKEDITOR.dialog.add('cosmohintDialog', this.path + 'dialogs/cosmohint.js');
      initDialog()
    },
  })
}
